/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Mic_CancelledInputs */

const en_us2_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recording discarded`)
};

const pt_br2_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áudio cancelado`)
};

const es_419_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio descartado`)
};

const pt_pt2_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áudio cancelado`)
};

const fr_fr2_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement supprimé`)
};

const de_de2_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahme verworfen`)
};

const it_it2_coach_mic_cancelled = /** @type {(inputs: Coach_Mic_CancelledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione scartata`)
};

/**
* | output |
* | --- |
* | "Recording discarded" |
*
* @param {Coach_Mic_CancelledInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_mic_cancelled = /** @type {((inputs?: Coach_Mic_CancelledInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Mic_CancelledInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_mic_cancelled(inputs)
	if (locale === "es-419") return es_419_coach_mic_cancelled(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_mic_cancelled(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_mic_cancelled(inputs)
	if (locale === "de-DE") return de_de2_coach_mic_cancelled(inputs)
	if (locale === "it-IT") return it_it2_coach_mic_cancelled(inputs)
	return en_us2_coach_mic_cancelled(inputs)
});
export { coach_mic_cancelled as "coach-mic.cancelled" }